import React, { memo, useCallback, useMemo } from 'react';

import block from 'bem-cn';

import Button from 'components/Button';

import InputRow from './InputRow/InputRaw';
import './BetsInputsBlock.scss'
import { useSelector } from 'react-redux';

const b = block('bets-inputs-block-desktop');

const BetsInputsBlockComponent = memo(({ inputsData, handlers }) => {
  const locale = useSelector((state) => state.locale.locale);
  const { handleChangeState, handleSendLimits } = handlers;

  const entries = useMemo(() => Object.entries(inputsData), [inputsData]);

  const handleInputChange = useCallback(
    ({ key, value }) => {
      handleChangeState({ key, value });
    },
    [handleChangeState],
  );

  return (
    <div className={b()}>
      {entries.map(([key, value]) => (
        <InputRow
          key={key}
          inputKey={key}
          value={value}
          onChange={handleInputChange}
        />
      ))}

      <div className={b('submit-button')}>
        <Button callBack={handleSendLimits}>{locale.limitsChangeButton}</Button>
      </div>

    </div >
  );
});

export default BetsInputsBlockComponent;